import React, { useState, useContext, useEffect }from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonModal } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { useHistory } from 'react-router-dom';


//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/zPublic.css';


 export function Hotel_PrivacyStatement(props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);
    let [modal_open, setModal_open] = useState(false);

    let history = useHistory();

    useEffect(() => {

        setModal_open(true);

    })

    const goToHome = () => {
        history.push('/home');
        window.location.reload();
      };

    return (
            <React.Fragment>
                <IonModal isOpen={ modal_open }>
                    <IonHeader className='grid_checkInHeader'>
                        <h1>PRIVACY STATEMENT</h1>
                    </IonHeader>

                    <IonContent className='privacy_statement'>
                        <p>

                        Data Collection: Ghana Verified typically collect certain information to provide and improve their services. This may include personal information, such as your name, email address, or phone number, as well as non-personal information like device information and usage data.

                        Usage of Information: Ghana Verified may use the collected data to deliver and personalize the app's functionality, improve user experience, and develop new features.

                        Information Sharing: Ghana Verified may share your information with third parties for various purposes, such as service providers, business partners, or when required by law. They may also share aggregated or anonymized data that doesn't personally identify you.

                        Security Measures: Privacy statements generally mention that Ghana Verified takes measures to protect the information they collect, including the use of encryption and access controls.

                        Cookies and Similar Technologies: Ghana Verified may use cookies, web beacons, and other tracking technologies to collect information and improve the app's functionality or personalize content.

                        User Controls and Choices: Ghana Verified typically provide options for users to manage their privacy settings and control the types of information collected. This may include settings related to location data, or app permissions.

                        Third-Party Services: If Ghana Verified  integrate with third-party services or include links to external websites, the privacy statement may explain that those services have their own privacy practices, and Ghana Verified is not responsible for how they handle your information.


                        </p>

                    </IonContent>
                    <IonFooter class='appFooter'>
                        <IonButton onClick={() => goToHome()}>Close</IonButton>
                    </IonFooter>

                    {/*<App_Footer></App_Footer>*/}
                    </IonModal>
            </React.Fragment>

    );
};



export default Hotel_PrivacyStatement;